// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1EZS6","consentsList":"PatientConsents_consentsList__1B10e","consentsListEmpty":"PatientConsents_consentsListEmpty__2yzV6"};